import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import { CookieConsent } from "@/components/layout/CookieConsent";
import Index from "./pages/Index";
import About from "./pages/About";
import OurStory from "./pages/OurStory";

import Photography from "./pages/Photography";
import Cinematography from "./pages/Cinematography";
import ComboPackages from "./pages/ComboPackages";
import Photobooth from "./pages/Photobooth";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Auth from "./pages/Auth";
import Admin from "./pages/Admin";
import SetupAdmin from "./pages/SetupAdmin";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Galleries from "./pages/Galleries";
import GalleryDetail from "./pages/GalleryDetail";
import NotFound from "./pages/NotFound";
import Chat from "./pages/Chat";
import PayrollDetail from "./pages/PayrollDetail";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/about-pixie-clicks" element={<About />} />
              <Route path="/our-story-philosophy" element={<OurStory />} />
              
              <Route path="/photography-by-pixie-clicks" element={<Photography />} />
              <Route path="/cinematography" element={<Cinematography />} />
              <Route path="/combo-packages" element={<ComboPackages />} />
              <Route path="/photobooth" element={<Photobooth />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/setup-admin" element={<SetupAdmin />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/galleries" element={<Galleries />} />
              <Route path="/galleries/:slug" element={<GalleryDetail />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/payroll/:payrollId" element={<PayrollDetail />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <CookieConsent />
          </BrowserRouter>
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
